import { makeAutoObservable, runInAction } from "mobx";

export default class SystemVersionStore {
  systemVersions = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.systemVersions = [];
    runInAction(() => {
      this.systemVersions = data;
    });
  };

  deleteItem = (id) => {
    let newState = this.systemVersions.filter((item) => item.id !== id);
    this.systemVersions = [];
    this.systemVersions = newState;
  };
}
